document.addEventListener("DOMContentLoaded", () => {
  try {
    const emailInput = document.querySelector('input#email[placeholder*="@otp.customer.meama.ge"]');
    if (!emailInput) return;

    const main = emailInput.closest("div.mx-auto.ml-0.max-w-4xl");
    if (!main) return;

    console.log("✅ OTP customer detected — restructuring customer form...");

    // Locate grids
    const grids = main.querySelectorAll(".grid.grid-cols-1.gap-6.md\\:grid-cols-2");
    const contactGrid = grids[1]; // phone + email section
    const idGrid = grids[2]; // identification_number section
    const idBlock = idGrid?.querySelector("div");

    if (!contactGrid || !idGrid || !idBlock) {
      console.warn("⚠️ Some expected elements not found — skipping restructure.");
      return;
    }

    // Remove email block (OTP account has no email field)
    const emailBlock = contactGrid.querySelector('label[for="email"]')?.closest("div");
    if (emailBlock) {
      emailBlock.remove();
      console.log("🗑️ Email block removed.");
    }

    // Move ID block next to phone number
    contactGrid.appendChild(idBlock);
    idGrid.remove();
    console.log("🔀 ID block moved next to phone block.");

    // 🧱 Hide the password update block for OTP users
    const passwordBlock = document.querySelector('.w-full.space-y-4.rounded-lg.bg-white.p-6.shadow-md');
    if (passwordBlock) {
      passwordBlock.style.display = "none";
      console.log("🙈 Password update block hidden for OTP customer.");
    }

    console.log("🎉 Customer details form updated successfully!");
  } catch (err) {
    console.error("❌ Error while restructuring form:", err);
  }
});
